/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  initialQueryState,
  PaginationState,
  QUERIES,
  WithChildren,
} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from './QueryRequestProvider'
import {getAll} from '../../../../services/common_requests'
import { createFacilityResponseContext, Facility, initialFacilityQueryResponse } from './_models'

const QueryFacilityResponseContext = createFacilityResponseContext<Facility>(initialFacilityQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<any>(state)
  const updatedQuery = useMemo(() => state, [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {
    isFetching: isFetchingFacilitys,
    refetch: refetchData,
    data: dataResponse,
  } = useQuery(
    `${QUERIES.FACILITIES_LIST}-${JSON.stringify(query)}`,
    () => {
      return getAll(query, '/facilities')
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  return (
    <QueryFacilityResponseContext.Provider
      value={{
        isLoading: isFetchingFacilitys,
        refetchData,
        dataResponse,
        query,
      }}
    >
      {children}
    </QueryFacilityResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryFacilityResponseContext)

const useQueryResponseData = () => {
  const {dataResponse} = useQueryResponse();

  if (!dataResponse) {
    return [];  
  }
  return dataResponse.data;  
}
const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {dataResponse} = useQueryResponse()
  if (!dataResponse || !dataResponse.payload || !dataResponse.pagination) {
    return defaultPaginationState
  }

  return dataResponse.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
